<template>
  <transition name="el-zoom-in-top">
    <div ref="triggerContainer" class="trigger-display-container" v-if="initFlag" v-show="showFlag" @click="elementClick">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
    /**
     * 切换显示容器
     */
    export default {
        name: "TriggerDisplayContainer",
        props: {
            /**
             * 隐藏模式，
             * blur：失焦隐藏
             * manual：手动隐藏
             */
            mode: {
                type: String,
                default: 'blur'
            }
        },
        data() {
            return {
                initFlag: false,
                showFlag: false,
                timeoutHandle: null,
                eleClickNum: 0,
                docClickNum: 0,
            }
        },
        methods: {
            init() {
                if (!this.initFlag)
                    this.initFlag = true;
            },
            trigger() {
                this.init();
                if (this.showFlag) {
                    this.hide();
                } else {
                    this.show();
                }
            },
            elementClick() {
                this.eleClickNum++;
            },
            /**
             * 如果冒泡事件计数不同则隐藏组件
             */
            documentClick() {
                this.docClickNum++;
                if (this.docClickNum !== this.eleClickNum)
                    this.hide();
            },
            show() {
                this.showFlag = true;
                this.$nextTick(() => {
                    clearTimeout(this.timeoutHandle);
                    this.timeoutHandle = setTimeout(() => {
                        document.addEventListener('click', this.documentClick);
                    }, 0);
                    this.$emit("callback");
                });
            },
            hide() {
                document.removeEventListener('click', this.documentClick);
                this.eleClickNum = 0;
                this.docClickNum = 0;
                this.showFlag = false;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/baseComponent/TriggerDisplayContainer.vue